

const defaultState = {
    Stipendi_From_Presenza: null
}

export const stipendi = (state = defaultState, action) => {

    console.log(action.type);
    switch (action.type) {
        case 'Stipendi_From_Presenza':  //Stipendi画面からpresenzaを取得するときに使っている
            return {
                ...state,
                Stipendi_From_Presenza: action.value
            }
        case 'Stipendi_From_Presenza_Monthly':  //Stipendi画面からpresenzaを取得するときに使っている
            return {
                ...state,
                Stipendi_From_Presenza_Monthly: action.value.stipendio,
                OreTotale_From_Presenza_Monthly: action.value.totalOre
            }
        default: return state
    }
}   